<template>
  <div class="bg-gradient-primary">
    <div class="container">
      <br>
      <div class="card o-hidden border-0 shadow-lg">
        <div class="card-body p-0">
          <div class="row" style="min-height: 60vh">
            <div class="col-lg-5 d-none d-lg-block bg-register-image"></div>
            <div class="col-lg-7 my-auto">
              <div class="p-4">
                <div class="text-center">
                  <img class="logo mx-1 my-1" src="@/assets/lion.png"/>
                  <h4 class="mb-sm-2 mb-md-4">Passwort zurücksetzen!</h4>
                </div>
                <br>
                <form v-if="modus === 0" class="user" v-on:submit.prevent="onSubmit">
                  <div class="form-group row">
                    <div class="col-sm-6 mb-3 mb-sm-0">
                      <input v-model="userData.sPassword" type="password" class="form-control form-control-user"
                             placeholder="Neues Passwort">
                      <password-meter :password="this.userData.sPassword" @score="updatePasswordScore"
                                      style="margin: 10px auto; width: 80%"/>
                      <span v-if="this.errorData.sPassword"
                            class="text-danger ml-2">{{ this.errorData.sPassword }}</span>
                    </div>
                    <div class="col-sm-6">
                      <input v-model="userData.sPassword2" type="password" class="form-control form-control-user"
                             placeholder="Neues Passwort wiederholen">
                      <span v-if="this.errorData.sPassword2"
                            class="text-danger ml-2">{{ this.errorData.sPassword2 }}</span>
                    </div>
                  </div>

                  <button type="submit" class="btn btn-primary btn-user btn-block">Absenden
                  </button>
                </form>
                <div v-if="modus===1" class="text-center">
                  <h5>Das Passwort wurde zurückgesetzt.</h5>
                  <br>
                  Sie können sich nun wieder einloggen.
                  <br> <br> <br>
                </div>
                <hr>
                <div class="text-center">
                  <router-link class="small" to="/login">Zum Login!</router-link>
                </div>
                <div class="text-center">
                  <router-link class="small" to="/datenschutzPublic">Impressum & Datenschutzhinweise</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center mt-5">
      <img class="logo-lg" src="@/assets/findSolutions-trans.png"/>
    </div>
  </div>
</template>

<script>
import passwordMeter from 'vue-simple-password-meter'
import UserRegisterService from '../services/UserRegisterService'

export default {
  components: { passwordMeter },
  async mounted () {
    var q = this.$route.query
    if (q.token) {
      this.userData.token = q.token
    }
  },
  data () {
    return {
      passwordScore: 0,
      modus: 0,
      ouArr: [],
      userData: {
        id: 0,
        token: '',
        sPassword: '',
        sPassword2: ''
      },
      errorData: {
        sPassword: '',
        sPassword2: ''
      }
    }
  },
  methods: {
    updatePasswordScore ({ score }) {
      this.passwordScore = score
    },
    resetErrors () {
      // eslint-disable-next-line no-unused-vars
      for (const [key, value] of Object.entries(this.errorData)) {
        this.errorData[key] = ''
      }
    },
    onSubmit () {
      this.resetErrors()
      if (!this.userData.token) {
        this.$alert('Der übergebene Token ist ungültig!')
        return true
      }

      if (!this.userData.sPassword) {
        this.errorData.sPassword = 'Pflichtfeld!'
        return true
      }

      if (this.userData.sPassword && this.passwordScore < 2) {
        this.errorData.sPassword = 'Passwort ist zu unsicher!'
        return true
      }
      if (this.userData.sPassword !== this.userData.sPassword2) {
        this.errorData.sPassword2 = 'Passwörter stimmen nicht überein!'
        return true
      }

      UserRegisterService.update(this.userData)
        .then(response => {
          this.modus = 1
        })
        .catch(e => {
          if (this.$func.isset(e.response.data) && this.$func.isset(e.response.data.fieldErrors)) {
            e.response.data.fieldErrors.forEach(element => {
              this.errorData[element.name] = element.status
            })
          } else {
            this.$confirm('Der übergebene Link konnte nicht zugeordnet werden. Bitte die \'Passwort-vergessen-Funktion\' benutzen, um einen neuen Link zu erhalten.', 'Link ungültig!', 'question', {
              confirmButtonText: 'Zur Passwort-vergessen-Funktion',
              cancelButtonText: 'Abbrechen'
            }).then(() => {
              this.$router.push('/pwvergessen')
            }).catch(e => {
              return true
            })
          }
        })
    }
  },
  computed: {}
}
</script>

<style>

</style>
